import { Props_SnippetImageContent } from './ImageContent.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'


const SnippetImageContent = (props: Props_SnippetImageContent) => {
    const { snippet, heading, image, content, repeatable_link, link, background } = props

    const classHeadingVisibility = heading.visibility?.value === true ? 'snippet-content-column__heading--visible' : 'snippet-content-column__heading--hidden'
    const classSnippetLayout = `snippet-image-content--${snippet.layout?.value}`
    const classLinkAlignment = link.alignment?.value ? `snippet-image-content__button-container--${link.alignment.value}` : ''

    const backgroundMap = {
        'white': '#ffffff',
        'covea-dark-blue': '#122147',
        'covea-light-green': '#d6eac1',
        'covea-light-red': '#efded3',
        'covea-light-purple': '#e2d3f2',
        'covea-light-turquoise': '#c8eaed',
        'covea-light-yellow': '#eae8ad',
        'MAAF-dark-blue': '#0091a7',
        'MAAF-light-blue': '#e5f3f5',
        'MAAF-light-red': '#fef6f2',
        'MMA-light-green': '#d6eceb',
        'MMA-light-orange': '#f2e1b5',
        'MMA-dark-blue': '#1d3b6d',
        'GMF-dark-blue': '#144390',
        'GMF-light-blue': '#dfedff',
        'GMF-light-orange': '#fff4ed',
        'Fidelia-dark-green': '#269b38',
        'Fidelia-light-blue': '#e1f0fb',
        'Fidelia-light-green': '#ebf2e7'
    }
    
    

    
    const backgroundKey = background?.colour.value || 'colour-1'
    const backgroundValue = backgroundMap[backgroundKey as keyof typeof backgroundMap] || backgroundMap['colour-1']
    const darkBackgrounds = ['covea-dark-blue', 'MAAF-dark-blue', 'MMA-dark-blue', 'GMF-dark-blue', 'Fidelia-dark-green']
    const useWhiteText = darkBackgrounds.includes(backgroundKey) ? 'snippet-image-content--white-text' : ''

    return (
        <section className={`snippet-image-content ${classSnippetLayout} ${useWhiteText}`} style={{ backgroundColor: backgroundValue }}>
            <div className="snippet-image-content__container">
                {image?.src?.value &&
                    <figure className="snippet-image-content__container-image">
                        <img
                            loading="lazy"
                            src={image.src?.value}
                            className="snippet-image-content__image"
                            height="360"
                            width="600"
                            alt={image.alt?.value ? image.alt.value : ''}
                        />
                    </figure>
                }
                <div className="snippet-image-content__container-content">
                    {heading?.content?.value &&
                        <h2 className={`snippet-image-content__heading ${classHeadingVisibility}`}>{heading.content?.value}</h2>
                    }
                    <div className="snippet-image-content__content">
                        {CompileMarkdown(content.content?.value || '')}
                    </div>

                    
                    <div className={`snippet-image-content__button-container ${classLinkAlignment}`}>
                        {repeatable_link.map(({ linkHref, linkStyle, linkTarget, linkText }, index) => (
                            <div key={index + (linkHref?.value || '')} className="snippet-image-content__link-container">
                                <SnippetLink
                                    linkStyles={linkStyle?.value}
                                    className="snippet-image-content__link"
                                    url={linkHref?.value}
                                    openInNewTab={linkTarget?.value}
                                >
                                    {linkText?.value}
                                </SnippetLink>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </section>
    )
}

export default SnippetImageContent